/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/returns",
  shortTitle: "Returns",
  title: "Returns, exchanges and refunds",
  category: "Orders and delivery",
  summary: "How to request a return and how hygiene, food, workshop and condition issues are assessed.",
  updated: "5 November 2026",
  sections: [
    {
      heading: "Ask before sending",
      body: [
        "Do not send goods without written return authorisation. Email the order number, item, reason, condition and requested outcome. Customer care will confirm whether a return is needed and provide the authorised Hong Kong return address and packaging instructions. Unauthorised parcels may be misdirected and do not create automatic acceptance.",
      ],
    },
    {
      heading: "Change-of-mind requests",
      body: [
        `${siteConfig.operatingRegion} does not provide a universal cooling-off period for ordinary online retail purchases. Because ${siteConfig.brandName} has not confirmed a voluntary return window, the site does not publish an invented number of days. Unused change-of-mind requests may be considered before use or damage, but acceptance, return cost and any exchange depend on written approval and do not create a standing promise.`,
      ],
    },
    {
      heading: "Condition-sensitive goods",
      body: [
        "Opened or consumed chocolate cannot be resold; a used soap sack raises hygiene concerns; prints creased after delivery, textiles exposed to odour or moisture, and assembled or used household goods may have reduced value. Workshop attendance is governed by the workshop policy rather than a physical return. These condition rules do not block a valid claim about a defect, unsafe product, incorrect item or misleading description.",
      ],
    },
    {
      heading: "Assessment and refund route",
      body: [
        "For an inspection case, preserve the item, packing and any dispatch receipt through the decision. Once customer care approves repayment after receiving the return or adequate evidence, funds go back by the payment path used for purchase. Account posting is controlled by the relevant bank or provider, so this site states no invented settlement date.",
        "A change-of-mind limitation cannot be repurposed to defeat a valid complaint about fault, safety or material mismatch. The appropriate outcome is determined from the evidence and the protections that mandatorily apply.",
      ],
    },
  ],
};
